import React, { ChangeEvent } from 'react';

// interfaces
import { IPowerBiReportDatasetReduxValueBatch } from './../../types';
import { SelectOption } from 'types/select';

// redux
import { useAppSelector, useAppDispatch } from 'appState/storeHooks';
import {
	editBatchListItem,
	removeBatchListItem,
	addBatchListItemRow,
} from './../../store/powerBiReportDataSets.actions';

// components
import { Input } from 'dumb';
import { TableList, TableListCell, TableListRow } from 'dumb/tables/table-list';
import { Box, IconButton, Tooltip as MuiTooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

// phrases
import phrases from './../../powerBiReportDataSets.phrases';

const PowerBiReportDataSetsModalStep = (): JSX.Element => {
	const dispatch = useAppDispatch();
	const batchList = useAppSelector(
		(store) => store.globalAdministrationPowerBIReportDatasets.batchList
	);

	const handleUpdateEntry = (
		row: IPowerBiReportDatasetReduxValueBatch,
		type: keyof IPowerBiReportDatasetReduxValueBatch,
		value: string | null | SelectOption
	) => {
		const payload: Partial<IPowerBiReportDatasetReduxValueBatch> = {
			identifier: row.identifier,
			[type]: value,
		};

		dispatch(editBatchListItem(payload));
	};
	const handleDeleteRow = (identifier: string) => () =>
		dispatch(removeBatchListItem(identifier));
	const handleAddRow = () => dispatch(addBatchListItemRow());

	return (
		<>
			<TableList>
				<thead>
					<tr>
						<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
						<th>{phrases.MODAL_BATCH_STEP_LIST_DATASET}</th>

						<th />
					</tr>
				</thead>
				<tbody>
					{batchList.map((entry, i) => {
						const deleteRowButtonDisabled = batchList.length === 1;

						return (
							<TableListRow key={entry.identifier}>
								<TableListCell>{i + 1}</TableListCell>

								<TableListCell>
									<Input
										id="dataset-id"
										dataCy="batch-modal-dataset-id"
										placeholder="Enter dataset id..."
										value={entry.dataset_id}
										onChange={(event: ChangeEvent<HTMLInputElement>) =>
											handleUpdateEntry(entry, 'dataset_id', event.target.value)
										}
										required
									/>
								</TableListCell>

								<TableListCell>
									<IconButton
										onClick={handleDeleteRow(entry.identifier)}
										disabled={deleteRowButtonDisabled}
									>
										<DeleteIcon
											sx={{
												color: (theme) => theme.palette.warning.main,
											}}
										/>
									</IconButton>
								</TableListCell>
							</TableListRow>
						);
					})}
				</tbody>
			</TableList>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					mt: 2,
				}}
			>
				<MuiTooltip title={phrases.ADD_ROW_TOOLTIP}>
					<IconButton onClick={handleAddRow}>
						<AddIcon />
					</IconButton>
				</MuiTooltip>
			</Box>
		</>
	);
};

export default PowerBiReportDataSetsModalStep;
